// extracted by mini-css-extract-plugin
export default {"editor":"MailEditor_editor__FJ6xh","readOnly":"MailEditor_readOnly__iOpQk","toolbar":"MailEditor_toolbar__tYgCM"};